export default __webpack_public_path__ + "static/media/iconRotate.7d056d6d.svg";